export default {
    READ: "read",
    WRITE: "write"
  };
  